<script setup lang="ts">
import type { ProductUi } from './CartBox.vue'

const props = defineProps<{
  col?: boolean
  product: Pick<gen.SellerOrderProductsListingFragment, 'ref' | 'listing'>
  showActions?: boolean
  skipLink?: boolean
  order?: 'nevet'
}>()

const product2 = computed((): { isManual: boolean; product: ProductUi; productId: string } => {
  const product = props.product
  const ref = product.ref

  if (product?.listing) {
    return {
      isManual: false,
      productId: ref.product.id,
      product: {
        id: ref.product.id,
        departmentName: product?.listing?.departmentName || helpers.joinStringCb(', ', ref.product?.departments, (i) => i.value),
        title: product?.listing?.title || ref.product?.title?.value || '',
        imageSrc: ref.product?.image,
        slug: product?.listing.slug,
        totalPrice: product?.ref?.priceTotalFinal?.priceForHumans,
        totalPriceNum: undefined,
        qty: product?.ref.qty,
        lineItems: product?.ref.lineItems,
      } satisfies ProductUi,
    }
  }

  return {
    isManual: true,
    productId: ref.product.id,
    product: {
      id: ref.product.id,
      outOfStockMsg: undefined,
      departmentName: undefined,
      title: ref.product.title?.value || '',
      imageBox: undefined,
      imageSrc: ref.product.image,
      slug: undefined,
      option: undefined,
      discountMessage: undefined,
      totalPriceNum: ref.priceUnitFinal.number,
      totalPrice: ref.priceUnitFinal.priceForHumans,
      totalOld: undefined,
      lineItems: ref.lineItems,
      endAt: undefined,
    },
  }
})
</script>

<template>
  <CartBox :skip-link="skipLink || product2.isManual" :col :listing="product?.listing" :product="product2.product">
    <template v-if="showActions && !product2.isManual" #actions>
      <div class="_mta">
        <LazyOrderReviewLink v-if="product2.productId" :product-id="product2.productId" />
      </div>
    </template>
  </CartBox>
</template>
